import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.resize()
  }

  resize() {
    this.element.setAttribute("data-autoresize-clone-value", this.textareaTarget.value)
  }
}
